module.exports = __webpack_public_path__ + "9bd01d3c1c0dec473505c4064a3681ef.svg";